import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  superAdminDashboard,
  superAdminProfile,
  activeLinkDashboard,
  addNewClient,
  addNewAgency,
} from "../common/allLinks";
import SuperAdminDashboardOverview from "./SuperAdminDashboardOverview";
import SuperAdminDashboardClients from "./SuperAdminDashboardClients";
import SuperAdminDashboardAgencies from "./SuperAdminDashboardAgencies";
import LinkCommonComponent from "../common/LinkCommonComponent";

export default function SuperAdminDashboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // activeSuperAdminDashboardTabIndex
    localStorage.setItem("activeSuperAdminDashboardTabIndex", val);
  };

  useEffect(() => {
    localStorage.removeItem("activeSuperAdminDashboardAgencyDetailsTabIndex");
    localStorage.removeItem("activeSuperAdminDashboardClientDetailsTabIndex");
  }, []);

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={superAdminDashboard}
        profileLink={superAdminProfile}
        activeLink={activeLinkDashboard}
      />

      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <h1 className="mt-dashboard-title">Dashboard</h1>
        </div>
        <div className="mt-platform-tabs">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem("activeSuperAdminDashboardTabIndex")
            )}
            onSelect={handleOnSelect}
          >
            <div className="mt-sa-add-buttons-block">
              <LinkCommonComponent
                extraClassName="login-btn-link--superAdminAddBtn mr-15"
                linkPath={addNewClient}
                linkText="Add New Client"
              />
              <LinkCommonComponent
                extraClassName="login-btn-link--superAdminAddBtn"
                linkPath={addNewAgency}
                linkText="Add New Agency"
              />
            </div>
            <TabList>
              <Tab>Overview</Tab>
              <Tab>Clients</Tab>
              <Tab>Agencies</Tab>
            </TabList>
            <TabPanel>
              <SuperAdminDashboardOverview />
            </TabPanel>
            <TabPanel>
              <SuperAdminDashboardClients />
            </TabPanel>
            <TabPanel>
              <SuperAdminDashboardAgencies />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
